<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
                <el-form :inline="true" :model="formData">
                    <el-row >
                        <el-col :span="6" class="leftAlignTtem">
                                <el-form-item label="姓名">
                                    <el-input v-model="formData.name" placeholder="姓名 模糊匹配"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" class="leftAlignTtem">
                                <el-form-item label="工号">
                                    <el-input v-model="formData.workNo" placeholder="工号 精确匹配"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="leftAlignTtem">
                                <el-form-item label="登录时间">
                                    <el-date-picker type="date" placeholder="从" v-model="formData.loginTime1" format="yyyy-MM-dd"></el-date-picker>
                                    <span>-</span>
                                    <el-date-picker type="date" placeholder="到" v-model="formData.loginTime2" format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="gapRow">
                        <el-col :span="24" class="">
                            <el-form-item>
                            <el-button type="primary" @click="query" icon="el-icon-search"  round >查询</el-button>
                            <el-button round @click="reset">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="contentBox">
                <el-table :data="tableData" max-height="2000">
                    <el-table-column prop="createBy" label="姓名" ></el-table-column>
                    <el-table-column prop="workNo" label="工号" ></el-table-column>
                    <el-table-column prop="createDate" label="登录时间" ></el-table-column>
                    <el-table-column prop="loginResult" label="登录结果" ></el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[10,20,30,40,50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </el-container>
</template>

<script>
import request from '@/lib/utils'

export default {
  name: 'loginRecord',
  data () {
    return {
      formData: {
        name: '',
        workNo: '',
        loginTime1: '',
        loginTime2: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    query () {
      const that = this
      let requestData = {}
      Object.assign(requestData, that.formData)
      requestData.pageIndex = that.pageIndex
      requestData.pageSize = that.pageSize
      request.post('/login/queryLoginRecordByPage', requestData).then(res => {
        that.tableData = res.obj.list
        that.total = res.obj.total
      }
      ).catch(err => {
        that.$message.error(err)
      })
    },
    reset () {
      this.formData = {
        name: '',
        workNo: '',
        loginTime1: '',
        loginTime2: ''
      }
    },
    handleSizeChange (cureentSize) {
      this.pageSize = cureentSize
      this.query()
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.query()
    }
  },
  mounted () {
    this.query()
  }
}

</script>

  <style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:80% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .shortInput{
    width: 30%;
  }

  .longInput{
    width: 390%;
  }

  .expandForm{
    margin-left: 30px;
  }

  </style>



// WEBPACK FOOTER //
// src/page/subPage/LoginRecord.vue